module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAARklEQVQ4jWNgGD7A09Pzv6en539i1FFsETKfBZvE9u3bGSmyhWIX0NQVRLsA3RWenp7/sfFJcia2gGbEJonLFdhcMgoYGABCgSsrooGXTgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/icon-sort-asc.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/icon-sort-asc.png
// module chunks = styles